import { EProductType } from "./products.type";

/** Tipos de produto que suportam aba de jornada (LP / cotação) no painel. */
export function isJourneyProductType(type: string | undefined | null): boolean {
  if (!type) return false;
  return (
    type === EProductType.CREDIT ||
    type === EProductType.AUTO ||
    type === EProductType.MOTO ||
    type === EProductType.WARRANTY_INSURANCE ||
    type === EProductType.THEFT_INSURANCE
  );
}
